import { Injectable } from '@angular/core';
import { HelpTextDictionary } from '../../../core/model/help-text';
import { HelpTextFactory } from '../../../core/service/factory/help-text-factory.service';

@Injectable()
export class BuildingHelpTextService {
  constructor(private _factory: HelpTextFactory) {}

  getDictionary(): HelpTextDictionary {
    return {
      NAME: this._factory.create('BUILDING_FORM.HELP_TEXT.NAME'),
      BUILDINGADDRESS: this._factory.create('BUILDING_FORM.HELP_TEXT.BUILDINGADDRESS'),
    };
  }
}
